import "../editors/html/HtmlArea.js";
import Backend from "../rest/Backend.js";
import Feedback from "../editors/feedback/Feedback.js";
import {Window} from "../chart/Window.js";
import ListManager from "../list/ListManager.js";
import {msg} from "@/i18n/Message.ts";

class DataHolder {
	constructor(initialHTML) {
		this.data = initialHTML;
	}

}

const NOTE_ROW_CLASS = "comment-row";

export class CrmComment extends HTMLElement {

	constructor() {
		super();
	}

	syncDisabled() {
		if (this.area) this.area.disabled = this.disabled;
	}

	timeToSave(e) {
		if (this.area.dirty) {
			this.storeBody();
		}
	}

	deleteNote() {
		if (this.noteId) {
			const backup = this.toJson();
			Backend.deleteJson("/comments/"+this.noteId)
				.then(response => {
					if (response.ok) {
						this.area.dirty = false;
						this.noteId = "0";
						this.deleteFeedback(backup);
					} else {
						this.reportError(response);
					}
					return response;
				})
				.catch(ex => {
					this.reportException(ex);
				});
		} else {
			// not yet saved
			this.area.dirty = false;
			this.deleteFeedback();
		}
	}

	storeBody() {
		let call;
		if (this.noteId) {
			// Existing note
			call = Backend.patchJson("/comments/" + this.noteId, this.toBodyJson(), true)
				.then(response => {
					if (response.ok) {
						if (this.area) this.area.dirty = false;
						this.reportOk();
					} else {
						this.reportError(response);
					}
					return response;
				});
		} else {
			// Create new note
			call = Backend.postJson("/comments", this.toJson(), true)
				.then(response => {
					if (response.ok) {
						if (this.area) {
							this.area.dirty = false;
							this.flagsDirty = false;
							this.initFromJsonPromise(response.json())
						}
						this.reportOk();
					} else {
						this.reportError(response);
					}
					return response;
				});
		}
		call.catch(ex => {
			this.reportException(ex);
		});
	}

	storeFlags() {
		if (this.noteId) {
			Backend.patchJson("/comments/"+this.noteId, this.toFlagsJson(), true)
				.then(response => {
					if (response.ok) {
						this.flagsDirty = false;
						this.reportOk();
					} else {
						this.reportError(response);
					}
					return response;
				})
				.catch(ex => {
					this.reportException(ex);
				});
		}
	}

	reportOk() {
		Feedback.saved(this);
	}

	reportError(response) {
		Feedback.error(this, response.status+" "+response.statusText);
		console.log("ERROR: "+response.status+" "+response.statusText);
	}

	reportException(ex) {
		let text = ex.toString();
		if (text.length > 40) text = text.substring(0, 40).concat("…");
		Feedback.error(this, text);
		console.log("EXCEPTION: "+ex);
	}

	toolbarAction(e) {
		console.log("Toolbar action was " + e.detail);
		switch (e.detail) {
			case "editPin":
				this.showPinSettings();
				break;
			case "deleteNote":
				this.deleteNote();
				break;
		}
	}

	isPinType(type) {
		if (typeof type === "string") type = parseInt(type);
		return this.pinTypes.indexOf(type) >= 0;
	}

	setPinType(type, ison) {
		if (typeof type === "string") type = parseInt(type);
		const current = this.pinTypes;
		if (ison) {
			if (current.indexOf(type) < 0) {
				// Need to add
				current.push(type);
				this.pinTypes = current;
			}
		} else {
			let idx;
			if ((idx = current.indexOf(type)) >= 0) {
				// Need to be removed
				current.splice(idx, 1);
				this.pinTypes = current;
			}
		}
	}

	showPinSettings() {
		if (this.systemNote) return;	// cannot edit system notes
		const dialog = new Window("Okno", (bodyelm) => {
			ListManager.getList("#noca").then(noca => {
				/*const chboxes = document.createElement("div");
				chboxes.style.display = "flex";
				chboxes.style.flexDirection = "column";
				chboxes.style.rowGap = "4px";

				for (let listItem of noca.items) {
					const row = document.createElement("div");
					const label = document.createElement("label");
					const chbox = document.createElement("input");
					chbox.setAttribute("type", "checkbox");
					chbox.setAttribute("value", listItem.value);
					if (this.isPinType(listItem.value)) chbox.setAttribute("checked", "");
					label.append(chbox);
					label.append(document.createTextNode(" " + listItem.name));
					row.append(label);
					chboxes.append(row);
					chbox.addEventListener("change", (e)=> {
						this.setPinType(listItem.value, chbox.checked);
					});
				}
				bodyelm.append(chboxes);*/
				const fcrow = document.createElement("div");
				const fclabel = document.createElement("label");
				const fcchbox = document.createElement("input");
				fcchbox.setAttribute("type", "checkbox");
				fclabel.append(fcchbox);
				fclabel.append(document.createTextNode(" "+msg("comment.forCustomer")))
				fcrow.append(fclabel);
				fcrow.style.marginTop = "8px";
				if (this.forCustomer) fcchbox.setAttribute("checked", "");
				bodyelm.append(fcrow);
				fcchbox.addEventListener("change", (e)=> {
					this.forCustomer = fcchbox.checked;
				});
			});
			return null;
		}, "pin", "window-body-gap");
		dialog.setCloseCallback(()=>{
			if (this.flagsDirty) {
				this.storeFlags();
			}
		})
		dialog.open();
	}

	/** Called when this note was successfully deleted */
	deleteFeedback(backup) {
		const rowElement = this.findNoteRow();
		Feedback.delete(rowElement).addEventListener("finish", ()=>{
			replaceWithUndoButton(rowElement);
		});
	}

	connectedCallback() {
		if (!this.area) {
			let children = this.removeCurrentContent();
			this.area = document.createElement("html-area");
			if (!this.disabled) {
				this.area.addSeparator();
				if (this.pin) {
					this.area.addButton("editPin", "pin");
				}
				this.area.addButton("deleteNote", "trash");
			}
			this.area.setAttribute("clickable", "true");
			this.area.classList.add("comment");
			if (this.forCustomer) this.area.classList.add("for-customer");
			if (this.systemNote) this.area.classList.add("system-note");
			this.syncDisabled();
			this.area.append(...children);
			this.area.addEventListener("editstop", this.timeToSave.bind(this));
			this.area.addEventListener("toolbaraction", this.toolbarAction.bind(this));
			this.appendChild(this.area);
			this.flagsDirty = false;
		}
	}

	focus(opts) {
		if (this.area) this.area.focus(opts);
	}

	blur() {
		if (this.area) this.area.blur();
	}

	disconnectedCallback() {
	}


	set disabled(value) {
		const isDisabled = Boolean(value);
		if (isDisabled) this.setAttribute('disabled', '');
		else this.removeAttribute('disabled');
		this.syncDisabled();
	}

	get disabled() {
		return this.hasAttribute('disabled');
	}

	set pin(value) {
		const isDisabled = Boolean(value);
		if (isDisabled) this.setAttribute('pin', '');
		else this.removeAttribute('pin');
	}

	get pin() {
		return this.hasAttribute('pin');
	}

	set forCustomer(value) {
		const isDisabled = Boolean(value);
		if (isDisabled) this.setAttribute('for-customer', '');
		else this.removeAttribute('for-customer');
	}

	get forCustomer() {
		return this.hasAttribute('for-customer') && this.getAttribute("for-customer")!=="false";
	}

	set systemNote(value) {
		const isDisabled = Boolean(value);
		if (isDisabled) this.setAttribute('system-note', '');
		else this.removeAttribute('system-note');
	}

	get systemNote() {
		return this.hasAttribute('system-note');
	}

	set srcType(value) {
		const numValue = parseInt(value);
		if (isNaN(numValue)) this.removeAttribute('src-type');
		else this.setAttribute('src-type', numValue.toString());
	}

	get srcType() {
		const ni = parseInt(this.getAttribute("src-type"));
		return isNaN(ni) ? 0 : ni;
	}

	set srcId(value) {
		if (value && value !== "0") this.setAttribute('src-id', value);
		else this.removeAttribute('src-id');
	}

	get srcId() {
		const ni = this.getAttribute("src-id");
		return ni ? ni : "0";
	}

	set noteId(value) {
		const numValue = parseInt(value);
		if (isNaN(numValue) || numValue === 0) this.removeAttribute('comment-id');
		else this.setAttribute('comment-id', numValue.toString());
	}

	get noteId() {
		const ni = parseInt(this.getAttribute("comment-id"));
		return isNaN(ni) ? 0 : ni;
	}

	set pinTypes(value) {
		if (value) {
			if (Array.isArray(value)) this.setAttribute("pin-types", value.join(","));
			else this.setAttribute("pin-types", value);
		} else this.removeAttribute("pin-types");
	}

	get pinTypes() {
		const types = this.getAttribute("pin-types");
		const retval = [];
		if (types) {
			for (let type of types.split(",")) {
				const v = parseInt(type);
				if (!isNaN(v)) retval.push(v);
			}
		}
		return retval;
	}

	static get observedAttributes() {
		return ['disabled', 'pin-types', 'for-customer'];
	}
	attributeChangedCallback(name, oldValue, newValue) {
		switch (name) {
			case "disabled":
				this.syncDisabled();
				break;
			case "pin-types":
				this.flagsDirty = true;
				break;
			case "for-customer":
				this.flagsDirty = true;				
				if (this.area) {
					if (newValue === null || newValue === false || newValue === "false") this.area.classList.remove("for-customer");
					else this.area.classList.add("for-customer");
				}
				break;
		}
	}

	removeCurrentContent() {
		const output = []
		for (let ch of this.childNodes) {
			output.push(ch);
		}
		this.innerHTML = "";
		return output;
	}

	toBodyJson() {
		return {
			html: true,
			content: this.area.safeInnerHTML
		}
	}

	toJson() {
		const o = {};
		o.id = this.noteId;
		o.srcType = this.srcType;
		o.srcId = this.srcId;
		o.forCustomer = this.forCustomer;
		o.html = true;
		o.content = this.area.safeInnerHTML;
		o.types = this.pinTypes;

		if (o.id === 0) delete o.id;
		if (o.srcId === "0") {
			delete o.srcId;
			delete o.srcType;
		}
		return o;

	}

	toFlagsJson() {
		const o = {};
		o.forCustomer = this.forCustomer;
		o.types = this.pinTypes;
		return o;

	}

	initFromJsonPromise(promise) {
		promise.then(json => {
			this.initFromJson(json);
		})
	}

	initFromJson(o, setBody = false) {
		this.noteId = o.id;
		this.srcType = o.srcType;
		this.srcId = o.srcId;
		this.forCustomer = o.forCustomer;
		if (this.area && setBody) {
			if (o.html) this.area.innerHTML = o.body;
			else this.area.innerText = o.body;
		}
		this.pinTypes = o.types;
	}

	findNoteRow() {
		let parent = this;
		do {
			parent = parent.parentElement;
		} while (parent && !parent.classList.contains(NOTE_ROW_CLASS))
		return parent;
	}
}


export function insertNewNoteEditor(container, usrLogin, usrName, srcType, srcId, atEnd = false) {
	const nrow = document.createElement("div");
	nrow.className = NOTE_ROW_CLASS;
	// Avatar
	const avatar = document.createElement("img");
	avatar.className = "chat-message-avatar";
	avatar.setAttribute("src", "avatar/" + usrLogin);
	if (usrName) avatar.setAttribute("title", usrName);
	nrow.append(avatar);

	const noteWrap = document.createElement("div");

	// Note <crm-note pin src-type="<%= srcType %>" src-id="<%= srcId %>" note-id="<%= row.getId() %>"><%= row.getNoteAsHtml() %></crm-note>
	const note = document.createElement("crm-comment");
	note.setAttribute("pin", "");
	note.setAttribute("src-type", srcType);
	note.setAttribute("src-id", srcId);
	noteWrap.append(note);
	const noteInfo = document.createElement("div");
	noteInfo.className = "comment-info";
	noteInfo.innerHTML = "&nbsp;";
	noteWrap.append(noteInfo);

	nrow.append(noteWrap);

	if (atEnd) container.append(nrow);
	else container.prepend(nrow);
	note.focus();
}

function replaceWithUndoButton(previousRow) {
	const nrow = document.createElement("div");
	nrow.className = NOTE_ROW_CLASS;
	const avatar = document.createElement("span");
	avatar.className = "chat-message-avatar-placeholder";
	nrow.append(avatar);
	const button = document.createElement("button");
	button.setAttribute("type", "button");
	const icon = document.createElement("f-icon");
	icon.setAttribute("name", "change");
	button.append(icon);
	button.append(document.createTextNode(" " + msg("bas.undo")));
	nrow.append(button);
	previousRow.replaceWith(nrow);
	button.addEventListener("click", (e) => {
		nrow.replaceWith(previousRow);
		previousRow.querySelector("crm-comment").storeBody();
	});
}

customElements.define("crm-comment", CrmComment);
